import {
	Modal,
	MimaButton,
	MimaInput,
	MimaDropdown,
	MimaTextArea,
	ReceiptCheckBox as RCB,
	MimaText,
} from '../../components';
import styles from '../../assets/styles/Inventory/Inventory.module.scss';
import { Field, FieldArray, Formik } from 'formik';
import { currencies } from '../../utils/utils';
import { inventoryStore } from '../../stores';
import React from 'react';

const FieldInput = ({ field, ...props }) => {
	return <MimaInput {...field} {...props} />;
};

const FieldSelect = ({ field, ...props }) => {
	return <MimaDropdown {...field} {...props} />;
};

const EditStock = ({ closeModal, loading, validationSchema, onSubmit, varyType, setVaryType, onSelect }) => {
	const { selectedStock } = inventoryStore;

	const variationTypeData = selectedStock?.product?.type === "Product" ? ([
		'Colour',
		'Size',
		'Weight',
		'Length',
		'Yards',
		'Time',
		'Soft',
		'Mild',
		'Hard',
		'Portion',
		'Bowl',
		'Bottle',
		'Carton',
		'Litre (lt)',
		'Bundle',
		'Sachets',
		'Millilitre (ml)',
		'Ounce (Oz)',
		'Gallon',
		'Inches',
		'Session',
		'Hours',
		'Location',
		'Grade',
		'Day',
		'Month',
		'Minutes',
	]) : ([
		'Session',
		'Hours',
		'Location',
		'Day',
		'Month',
		'Minutes',
		'Time',
	])

	const eurAmount = inventoryStore?.eurPrice;
	const gbpAmount = inventoryStore?.gbpPrice;

	return (
		<Modal closeModal={closeModal} goBack={closeModal}>
			<MimaText variant="subtitleBold" align="center" mb={2} color="var(--color-primary)">
				Edit {selectedStock?.product?.name} - {selectedStock?.title} Stock
			</MimaText>
			<Formik
				initialValues={{
					title: selectedStock.title || '',
					// costPrice: selectedStock.costPrice,
					sellingPrice: selectedStock.sellingPrice,
					quantity: selectedStock.quantity,
					currencyCode: selectedStock.currencyCode,
					splitPercentage: selectedStock.splitPercentage || 0,
					description: selectedStock.description || '',
					// shippingFee: selectedStock.shippingFee || 0,
					variations:
						selectedStock.variations?.map(v => {
							return {
								type: v.type,
								value: v.value,
							};
						}) || [],
					validCondition: selectedStock?.product?.type === "Product" ? true : false,
					sellingPriceUSD: selectedStock?.sellingPriceUSD,
					sellingPriceGBP: selectedStock?.sellingPriceGBP,
					sellingPriceEUR: selectedStock?.sellingPriceEUR,
					sellingPriceNGN: selectedStock?.sellingPriceNGN,
					hasMulticurrency: selectedStock?.sellingPriceUSD === 0 ? false : true,
					productCondition: selectedStock?.productCondition,
				}}
				validationSchema={validationSchema}
				onSubmit={onSubmit}>
				{({
					handleChange,
					handleBlur,
					handleSubmit,
					values,
					errors,
					touched,
					setFieldValue,
				}) => (
					<div>
						<MimaInput
							type="text"
							labelTitle="Stock Title"
							name="title"
							id="title"
							value={values.title}
							onChange={handleChange}
							error={errors.title}
							touched={touched.title}
							onBlur={handleBlur}
						/>

						<FieldArray name="variations">
							{({ push, remove }) => (
								<React.Fragment>
									{values.variations.map((_, i) => (
										varyType && <div key={i}>
											<div className="modal__beside">
												<Field
													as="select"
													component={FieldSelect}
													name={`variations.${i}.type`}
													value={values.variations[i].type}
													onChange={e => {
														setFieldValue(`variations.${i}.type`, e.value);
													}}
													placeholder={
														values.variations[i].type || 'Select type'
													}
													data={variationTypeData.map(item => ({
														key: item,
														value: item,
													}))}
													labelTitle="Stock Tag"
													width={18}
												/>
												<Field
													name={`variations.${i}.value`}
													type="text"
													component={FieldInput}
													labelTitle="Value"
													width={18}
												/>
											</div>
											{i >= 0 ? (
												<MimaButton
													title="Remove"
													variant="filter"
													type="button"
													buttonColor="var(--color-error)"
													width={10}
													onClick={() => {
														if (values.variations.length === 1) {
															setVaryType(false)
														} else {
															remove(i);
														}
													}}
												/>
											) : (
												''
											)}
											<div className={styles.employee__list_line}> </div>
										</div>
									))}
									<MimaButton
										title={varyType ? "Add Another Tag" : "Add Tag"}
										variant="text"
										type="button"
										onClick={() => {
											if (!varyType && values.variations.length === 1) {
												setVaryType(true)
											} else {
												push({
													value: '',
													type: '',
												})
											}
										}}
										width={38}
									/>
								</React.Fragment>
							)}
						</FieldArray>
						<div className={styles.type}>
							<MimaText variant="small" mb={1} mt={3}>
								Condition of Stock
							</MimaText>
							<div className="modal__beside">
								<RCB
									title="Brand New"
									onChange={() => {
										setFieldValue('productCondition', 'NEW');
									}}
									checked={values.productCondition === 'NEW'}
									value={'NEW'}
									name="productCondition"
								/>
								<RCB
									title="Fairly Used"
									onChange={() => {
										setFieldValue('productCondition', 'USED');
									}}
									checked={values.productCondition === 'USED'}
									value={'USED'}
									name="productCondition"
								/>
							</div>
							{errors.productCondition ? (
								<div className={styles.error}>
									{''}
									{touched.productCondition && errors.productCondition}
									{''}
								</div>
							) : null}
						</div>

						<MimaTextArea
							type="text"
							labelTitle="Description"
							name="description"
							id="description"
							value={values.description}
							onChange={handleChange}
							error={errors.description}
							touched={touched.description}
							onBlur={handleBlur}
						/>
						<div className='modal__beside'>
							<MimaDropdown
								labelTitle="Select Currency"
								name="currencyCode"
								value={values.currencyCode}
								placeholder={values.currencyCode}
								id="currencyCode"
								currentValue={values.currencyCode}
								onChange={data => {
									setFieldValue('currencyCode', data.key);
								}}
								data={currencies}
								touched={touched.currencyCode}
								error={errors.currencyCode}
								width={selectedStock?.product?.type === "Product" ? 18 : 38}
							/>


							{selectedStock?.product?.type === "Product" ?
								<MimaInput
									type="number"
									labelTitle="Available Quantity"
									name="quantity"
									id="quantity"
									value={values.quantity}
									onChange={handleChange}
									error={errors.quantity}
									touched={touched.quantity}
									onBlur={handleBlur}
									width={18}
									disabled
								/> : " "}
						</div>
						<div className="modal__beside">
							{/* <MimaInput
								type="number"
								labelTitle="Cost Price"
								name="costPrice"
								id="costPrice"
								value={values.costPrice}
								onChange={handleChange}
								error={errors.costPrice}
								touched={touched.costPrice}
								onBlur={handleBlur}
								width={18}
							/> */}
							<MimaInput
								type="number"
								labelTitle="Selling Price"
								name="sellingPrice"
								id="sellingPrice"
								value={values.sellingPrice}
								onChange={handleChange}
								error={errors.sellingPrice}
								touched={touched.sellingPrice}
								onBlur={handleBlur}
							// width={18}
							/>
						</div>

						{/* <MimaInput
								type="number"
								labelTitle={selectedStock?.product?.type === "Product" ? "Shipping Fee" : "Logistics Fee"}
								name="shippingFee"
								id="shippingFee"
								value={values.shippingFee}
								onChange={handleChange}
								error={errors.shippingFee}
								touched={touched.shippingFee}
								onBlur={handleBlur}
								width={selectedStock?.product?.type === "Product" ? 18 : 38}
									/> */}

						<div className={styles.type}>
							<RCB
								title="Do you want to accept Multicurrency for this stock."
								onChange={() => {
									setFieldValue('hasMulticurrency', !values.hasMulticurrency);
								}}
								checked={values.hasMulticurrency}
								value={values.hasMulticurrency}
								name="hasMulticurrency"
							/>
							{errors.hasMulticurrency ? (
								<div className={styles.error}>
									{''}
									{touched.hasMulticurrency && errors.hasMulticurrency}
									{''}
								</div>
							) : null}
						</div>

						{values.hasMulticurrency && (
							<>
								<div className={styles.addProduct__beside}>
									<MimaInput
										type="number"
										labelTitle="USD"
										name="sellingPriceUSD"
										id="sellingPriceUSD"
										value={values.sellingPriceUSD}
										onChange={handleChange}
										error={errors.sellingPriceUSD}
										touched={touched.sellingPriceUSD}
										onBlur={(e) => {
											handleBlur(e)
											onSelect(values)
											setFieldValue('sellingPriceEUR', eurAmount);
											setFieldValue('sellingPriceGBP', gbpAmount);
										}}
										width={12}
									/>
									<MimaInput
										type="number"
										labelTitle="GBP"
										name="sellingPriceGBP"
										id="sellingPriceGBP"
										value={values.sellingPriceGBP}
										onChange={handleChange}
										error={errors.sellingPriceGBP}
										touched={touched.sellingPriceGBP}
										onBlur={handleBlur}
										width={12}
									/>

									<MimaInput
										type="number"
										labelTitle="EUR"
										name="sellingPriceEUR"
										id="sellingPriceEUR"
										value={values.sellingPriceEUR}
										onChange={handleChange}
										error={errors.sellingPriceEUR}
										touched={touched.sellingPriceEUR}
										onBlur={handleBlur}
										width={12}
									/>
								</div>
							</>
						)}

						{selectedStock?.product?.hasSplit && (
							<MimaInput
								type="number"
								min={0}
								max={100}
								labelTitle={`How many percent belongs to ${selectedStock?.product?.name}?`}
								name="splitPercentage"
								id="splitPercentage"
								value={values.splitPercentage}
								onChange={handleChange}
								touched={touched.splitPercentage}
								onBlur={handleBlur}
							/>
						)}
						<MimaButton
							title="Save Edit"
							onClick={handleSubmit}
							variant="form"
							loading={loading}
						/>
					</div>
				)}
			</Formik>
		</Modal>
	);
};

export default EditStock;
